import React from 'react';
import { TextVariant } from '@naf/text';
// eslint-disable-next-line import/no-unresolved
import loadable from '@loadable/component';
import { CarMeta } from '@appTypes/carModelType';
import { PayWallSerializer } from '@components/block-content/types/serializers/contextual';
import { InfoBox } from './InfoBox';
import { SectionHeader } from './ModelDetailPage/Styles';
import { RangeTestContent } from './RangeTestContent';
import * as S from './RangeTests.styles';
import { TestTabs } from './TestTabs';
import { useRangeTestGroups } from './useRangeTestGroups';

export { formatTestSeason } from './RangeTests.utils';
export { Caption, ContentHeader } from './RangeTests.styles';

const Paywall = PayWallSerializer();
const GoogleMapsWrapper = loadable(() => import('@components/SectionBlocks/blocks/Charts/GoogleMapsWrapper'), {
  resolveComponent: (components) => components.GoogleMapsWrapper,
});

type Props = Pick<CarMeta, 'rangeTests' | 'cloudinaryImages' | 'chargeTests'> & {
  rangeTestInfoBox: CarMeta['globalContent']['rangeTestInfoBox'];
  slug: string;
  userAccessibility?: CarMeta['userAccessibility'];
};

export const RangeTests: React.FC<Props> = ({
  rangeTests,
  rangeTestInfoBox,
  cloudinaryImages,
  slug,
  chargeTests,
  userAccessibility,
}) => {
  const { tabContexts, selectedTab, selectTabByKey } = useRangeTestGroups(rangeTests, chargeTests);
  const isAccessible = userAccessibility?.isAccessibleForUser !== false;

  const paywall = !isAccessible && userAccessibility?.paywallOptions && (
    <S.PaywallWrapper>
      <Paywall
        value={{
          paywallOptions: userAccessibility.paywallOptions,
          paywallLink: userAccessibility.paywallLink,
          paywallLinkSecondary: userAccessibility.paywallLinkSecondary,
        }}
      />
    </S.PaywallWrapper>
  );

  const items = tabContexts.map(({ key, value, tests }) => ({
    value: key,
    label: value,
    content: isAccessible ? <RangeTestContent slug={slug} tests={tests} sanityImages={cloudinaryImages} /> : paywall,
  }));

  return (
    <>
      <S.ScrollAnchorTag id="rekkeviddetester">
        <SectionHeader variant={TextVariant.Header1} tag="h2">
          Test av rekkevidde
        </SectionHeader>
      </S.ScrollAnchorTag>
      <GoogleMapsWrapper>
        {/* Each panel draws an ElevationChart the legacy TabPanel kept mounted, so keep them —
            except when paywalled, where every panel would hold its own copy of the paywall. */}
        <TestTabs items={items} selectedTab={selectedTab} onSelectTab={selectTabByKey} keepMounted={isAccessible} />
      </GoogleMapsWrapper>
      {isAccessible && rangeTestInfoBox && <InfoBox title={rangeTestInfoBox.title} text={rangeTestInfoBox.text} />}
    </>
  );
};
